

















































































































































































































































import IStock from '@/store/models/IStock';
import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import CustomerDashboardApi from '../store/api/CustomerDashboardApi';
import PrintingApi from '../store/api/PrintingApi';
import CustomerStockSelector from '@/components/selectors/CustomerDashboard/CustomerStockSelector.vue';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IInbound from '@/store/models/IInbound';
import CustomerInboundsSelector from '@/components/selectors/CustomerDashboard/CustomerInboundsSelector.vue';
import InboundPictureApi from '../store/api/InboundPictureApi';
import IInboundPicture from '@/store/models/IInboundPicture';
import IBlob from '@/store/models/IBlob';
import IInboundDetail from '@/store/models/IInboundDetail';
import InboundDetailApi from '../store/api/InboundDetailApi';
import IOutbound from '@/store/models/IOutbound';
import CustomerOutboundsSelector from '@/components/selectors/CustomerDashboard/CustomerOutboundsSelector.vue';
import OutboundPictureApi from '../store/api/OutboundPictureApi';
import IOutboundPicture from '@/store/models/IOutboundPicture';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import OutboundDetailApi from '../store/api/OutboundDetailApi';
import IInboundDocument from '@/store/models/IInboundDocument';
import InboundDocumentApi from '@/store/api/InboundDocumentApi';
import IOutboundDocument from '@/store/models/IOutboundDocument';
import OutboundDocumentApi from '@/store/api/OutboundDocumentApi';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        Snackbar,
        CustomerStockSelector,
        CustomerInboundsSelector,
        CustomerOutboundsSelector

    }
})
export default class CustomerDashboard extends Vue {
    permissions : IRolePermission[] = [];
    idCustomer: string = "";
    idCompany: string = "";
    StockList : IStock[] = [];
    customerDashboardApi : CustomerDashboardApi;
    printingApi : PrintingApi;
    settingsCompanyApi: SettingsCompanyApi;
    uploadServiceApi : UploadServiceApi;
    InboundList: IInbound[] = [];
    selectedInbound : IInbound = {} as IInbound;
    inboundPictureApi : InboundPictureApi;
    inboundPictures : IInboundPicture[] = [];
    BlobsInbound: IBlob[] = [];
    inboundDetailList : IInboundDetail[] = [];
    inboundDetailApi : InboundDetailApi;
    OutboundList: IOutbound[] = [];
    selectedOutbound : IOutbound = {} as IOutbound;
    outboundPictureApi : OutboundPictureApi;
    outboundPictures : IOutboundPicture[] = [];
    BlobsOutbound: IBlob[] = [];
    outboundDetailList : IOutboundDetail[] = [];
    outboundDetailApi : OutboundDetailApi;
    enableOutboundPhotos : boolean = false;
    enableInboundPhotos : boolean = false;
    overlay: boolean = true;
    inboundDocuments : IInboundDocument[] = [];
    inboundDocumentApi : InboundDocumentApi;
    outboundDocuments : IOutboundDocument[] = [];
    outboundDocumentApi : OutboundDocumentApi;
    constructor() {
        super();
        this.customerDashboardApi = new CustomerDashboardApi();
        this.printingApi = new PrintingApi("CustomerDashboard");
        this.settingsCompanyApi = new SettingsCompanyApi("CustomerDashboard");
        this.uploadServiceApi = new UploadServiceApi("CustomerDashboard");
        this.inboundPictureApi = new InboundPictureApi("CustomerDashboard");
        this.inboundDetailApi = new InboundDetailApi("CustomerDashboard");
        this.outboundPictureApi = new OutboundPictureApi("CustomerDashboard");
        this.outboundDetailApi = new OutboundDetailApi("CustomerDashboard");
        this.inboundDocumentApi = new InboundDocumentApi("CustomerDashboard");
        this.outboundDocumentApi = new OutboundDocumentApi("CustomerDashboard");
    }

    async created() {
        this.overlay = true;
        this.getPermissions();

        await Promise.all([
            this.getCustomerStock(),
            this.getInbounds(),
            this.getOutbounds()
        ]);

        this.overlay = false;
    }

    get isSuperAdmin() {
        return this.idCompany === EMPTY_GUID;
    }

    async printCustomerStock(formatToPrint : string, warehouseName: string[], bestBeforeDate: string[], inboundCode: string[], goodName: string[]) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdStockListCustomerPrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
            if (idRepport) {
                let idCustomer : string[] = ["'" + this.idCustomer + "'"];
                let warehouseNames: string[] = [];
                let bestBeforeDates: string[] = [];
                let inboundCodes: string[] = [];
                let goodNames: string[] = [];
                if (warehouseName.length > 0) {
                    warehouseName.forEach(i => {
                        warehouseNames.push("'" + i + "'");
                    });
                }
                if (bestBeforeDate.length > 0) {
                    bestBeforeDate.forEach(i => {
                        bestBeforeDates.push("'" + i + "'");
                    });
                }
                if (inboundCode.length > 0) {
                    inboundCode.forEach(i => {
                        inboundCodes.push("'" + i + "'");
                    });
                }
                if (goodName.length > 0) {
                    goodName.forEach(i => {
                        goodNames.push("'" + i + "'");
                    });
                }
                let printLabelUrl: string = await this.printingApi.PrintCustomerStock(idRepport[0].value, idCustomer, warehouseNames, bestBeforeDates, inboundCodes, goodNames, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "CustomerStock.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    @Watch('inboundPictures')
    onChangedInboundPictures() {
        this.inboundPictures.forEach(async i => {
            let indexUrl = this.BlobsInbound.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.inboundId = this.selectedInbound.id;
                let index = this.BlobsInbound.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.BlobsInbound.push(blob);
                }
            }
        });
    }

    @Watch('outboundPictures')
    onChangedOutboundPictures() {
        this.outboundPictures.forEach(async i => {
            let indexUrl = this.BlobsOutbound.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.outboundId = this.selectedOutbound.id;
                let index = this.BlobsOutbound.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.BlobsOutbound.push(blob);
                }
            }
        });
    }

    async downloadOutboundPictures() {
        this.overlay = true;
        const urls = this.outboundPictures.map(element => element.url);
        if (this.selectedInbound) {
            const zipFileName = this.selectedInbound.code + "_" + new Date().toISOString().substr(0, 10);
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        }
        
        this.overlay = false;
    }

    async downloadInboundPictures() {
        this.overlay = true;
        const urls = this.inboundPictures.map(element => element.url);
        if (this.selectedOutbound) {
            const zipFileName = this.selectedOutbound.code + "_" + new Date().toISOString().substr(0, 10);
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        }
        
        this.overlay = false;
    }

    async getInbounds() {
        this.InboundList = await this.customerDashboardApi.GetInboundsByCustomer(this.idCustomer);
    }

    async getOutbounds() {
        this.OutboundList = await this.customerDashboardApi.GetOutboundsByCustomer(this.idCustomer);
    }

    async getCustomerStock() {
        this.StockList = await this.customerDashboardApi.GetStockGroupByPalletsAndCustomer(this.idCustomer);
        this.overlay = false;
    }

    async inboundChanged(inbound: IInbound) {
        if (inbound !== undefined && Object.keys(inbound).length !== 0) {
            this.enableInboundPhotos = true;
            this.selectedInbound = inbound;
            this.inboundPictures = await this.inboundPictureApi.GetInboundPictures(inbound.id);
            this.inboundDocuments = await this.inboundDocumentApi.GetInboundDocuments(inbound.id);
            this.inboundDetailList = await this.inboundDetailApi.GetInboundDetails(inbound.id);
        } else {
            this.enableInboundPhotos = false;
            this.selectedInbound = {} as IInbound;
            this.inboundPictures = [];
            this.inboundDocuments = [];
            this.BlobsInbound = [];
        }
    }

    async outboundChanged(outbound: IOutbound) {
        if (outbound !== undefined && Object.keys(outbound).length !== 0) {
            this.enableOutboundPhotos = true;
            this.selectedOutbound = outbound;
            this.outboundPictures = await this.outboundPictureApi.GetOutboundPictures(outbound.id);
            this.outboundDetailList = await this.outboundDetailApi.GetOutboundDetails(outbound.id);
            this.outboundDocuments = await this.outboundDocumentApi.GetOutboundDocuments(outbound.id);
        } else {
            this.enableOutboundPhotos = false;
            this.selectedOutbound = {} as IOutbound;
            this.outboundPictures = [];
            this.outboundDocuments = [];
            this.BlobsOutbound = [];
        }
    }

    async downloadInboundDocument(doc: IInboundDocument) {
        if (!doc || !doc.url) return;
        this.overlay = true;
        try {
            const safeName = this.buildDocumentFileName(doc.custompapername, doc.description);
            await this.uploadServiceApi.DownloadDocuments(doc.url, safeName);
        } finally {
            this.overlay = false;
        }
    }

    async downloadOutboundDocument(doc: IOutboundDocument) {
        if (!doc || !doc.url) return;
        this.overlay = true;
        try {
            const safeName = this.buildDocumentFileName(doc.custompapername, doc.description);
            await this.uploadServiceApi.DownloadDocuments(doc.url, safeName);
        } finally {
            this.overlay = false;
        }
    }

    async downloadInboundDocumentsZip() {
        this.overlay = true;
        try {
            const urls = this.inboundDocuments.map(d => d.url).filter(Boolean);
            if (urls.length === 0 || !this.selectedInbound) return;

            const zipFileName = `${this.selectedInbound.code}_Documents_${new Date().toISOString().substr(0, 10)}`;
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        } finally {
            this.overlay = false;
        }
    }

    async downloadOutboundDocumentsZip() {
        this.overlay = true;
        try {
            const urls = this.outboundDocuments.map(d => d.url).filter(Boolean);
            if (urls.length === 0 || !this.selectedOutbound) return;

            const zipFileName = `${this.selectedOutbound.code}_Documents_${new Date().toISOString().substr(0, 10)}`;
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        } finally {
            this.overlay = false;
        }
    }
    private buildDocumentFileName(custompapername: string, description: string): string {
        const base = `${custompapername || "Document"}_${description || ""}`.trim();
        // limpia caracteres raros para Windows
        const safe = base.replace('/[<>:"/\\|?*\x00-\x1F]/g', "_");
        // sin extensión porque no sabemos cuál es; si tu backend la conoce, mejor añadirla ahí
        return safe.length > 3 ? safe : "Document";
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCustomer = userFromStorage.idCustomer;
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "CustomerDashboard"));
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
